import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import {
	changeSelectedMenuItemId,
	closeNavigationDrawer,
} from "../../features/navigation-drawer/navigation-drawer-slice";
import NavDrawer from "../drawer/ui";
import { useEdgeBoxStyle } from "../drawer/use-edge-height-style";
import SupervisorHomeDashboard from "./ui/supervisor-home-dashboard";
import { HOME_MENU_ITEM_ID } from "./utils/constants";

const SupervisorHome = () => {
	const dispatch = useDispatch();
	const boxStyle = useEdgeBoxStyle();

	useEffect(() => {
		dispatch(changeSelectedMenuItemId(HOME_MENU_ITEM_ID));
		dispatch(closeNavigationDrawer());
	}, [dispatch]);

	return (
		<Box
			sx={{
				...boxStyle,
				display: "flex",
				backgroundColor: "#F5F5F5",
				width: "100%",
			}}
		>
			<CssBaseline />
			<NavDrawer keepSettingOpen={false} />
			{/* design/wilya-page-layout is pinned to minWidth 1364px for the wide
			data tables it was built for, which forces the whole app frame to
			scroll horizontally. This page wraps on its own, so it uses the same
			shell without the floor. */}
			<Box
				component='main'
				sx={{
					flexGrow: 1,
					minWidth: 0,
					m: { xs: 1, md: 3 },
					backgroundColor: "#fff",
					borderRadius: "15px",
				}}
			>
				<SupervisorHomeDashboard />
			</Box>
		</Box>
	);
};

export default SupervisorHome;
